import { SolaView, htmlSolaWithInstance } from '@hm-spt/sola';
import { findMenuPlace, menuHeading, renderMenuTabs } from '../components/menu';
import { assert } from '../lib/assert';
import { escapeHtml } from '../lib/cells';

interface MenuStubData {
  href: string;
}

/** 자리 페이지 — 메뉴 · 탭은 있고 화면은 아직 없는 자리. 탭 줄 · 하는 일 한 줄 · 새 탭 상세 · 버튼을 글로 보여 준다 */
export class MenuStubView extends SolaView<MenuStubData> {
  constructor(opts: { href: string }) {
    super();
    this.data = { href: opts.href };
  }

  override getTitle(): string {
    const place = findMenuPlace(this.data.href);
    return `${place === null ? '자리' : `${place.item.label} › ${place.tab.label}`} — HCLTech`;
  }

  render(): HTMLElement {
    const place = findMenuPlace(this.data.href);
    assert(place !== null, `메뉴에 없는 자리 페이지다: ${this.data.href} — MENU_GROUPS 의 탭에 먼저 올린다`);
    const detail = place.item.detail === null ? '' : `<p><b>줄을 누르면(새 탭)</b> ${escapeHtml(place.item.detail)}</p>`;
    const buttons = place.item.buttons.length === 0 ? '' : `<p><b>버튼</b> ${place.item.buttons.map(escapeHtml).join(' · ')}</p>`;
    return htmlSolaWithInstance(this)`
      <div class="page">
        <header class="page-header">
          <h1>${menuHeading(place)}</h1>
          ${renderMenuTabs(place)}
        </header>
        <div class="menu-stub">
          <p><b>${escapeHtml(place.tab.label)}</b> — ${escapeHtml(place.tab.what)}</p>
          ${detail}
          ${buttons}
          <p class="text-muted">자리만 있습니다 — 화면은 아직 없습니다. 데이터는 전이표 · 데이터 지도에 있고, 화면은 10월 범위에서 정합니다.</p>
        </div>
      </div>
    `;
  }
}
